var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 1,
    y: 1,
    width: 92,
    height: 92,
    rx: 46,
    fill: "#E7454C",
    stroke: "#E7454C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ic_Shield"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 73C47 73 28 66.2 28 46.6V30.5L47 27L66 30.5V46.6C66 66.4 47 73 47 73Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path ",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 25.4747L67.5 29.251V46.6C67.5 55.7299 63.7297 62.9332 57.4835 68.3575C55.3106 70.2445 52.9871 71.778 50.6619 72.9896C49.2572 73.7215 48.1516 74.1879 47.4922 74.4169L46.9926 74.5905L46.3468 74.3581C45.7802 74.1459 44.9448 73.7837 43.9117 73.259L43.329 72.9567C41.0057 71.7258 38.6842 70.1764 36.5131 68.2796C30.2697 62.8248 26.5 55.6426 26.5 46.6V29.251L47 25.4747ZM64.5 31.749L47 28.525L29.5 31.749V46.6C29.5 54.5419 32.7198 60.8385 38.145 65.7173L38.4869 66.0204C40.4721 67.7548 42.6036 69.1773 44.7335 70.3058C45.4765 70.6994 46.1642 71.0274 46.778 71.2923L47.006 71.389L47.0865 71.3571L47.546 71.1611C48.077 70.9282 48.6571 70.6514 49.2756 70.3291C51.4035 69.2204 53.5331 67.8148 55.5165 66.0924C61.1453 61.2042 64.5 54.795 64.5 46.6V31.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5131 50L46.8658 58.8523L66.1062 36.8523",
    fill: "#E7454C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check_2",
    d: "M64.9771 35.8648L67.2353 37.8398L47.9949 59.8398C47.4876 60.4198 46.6314 60.5159 46.0116 60.0855L45.891 59.9924L35.5383 51.14L37.4879 48.8599L46.712 56.748L64.9771 35.8648Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRel);
export default __webpack_public_path__ + "static/media/rel.198304876b499f0f3d6318b7f9a48ee4.svg";
export { ForwardRef as ReactComponent };